/* eslint-disable react/prop-types */
import React from "react";

const Link = _ref => {
  let {
    entityKey,
    contentState,
    children
  } = _ref;
  const {
    url
  } = contentState.getEntity(entityKey).getData();
  return /*#__PURE__*/React.createElement("a", {
    href: url
  }, children);
};

export default Link;